// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"57":"index","205":"third-mall","480":"special","965":"price-history"}[chunkId] + "." + {"57":"713c26d2","205":"d94485cd","480":"49ac60d0","965":"4a7400d1"}[chunkId] + ".css";
};